<template>
  <div class="c-desk" :class="{'c-desk--dark': stage !== 0}">
    <div class="c-desk__inner">
      <div class="o-aspect">
        <div class="o-aspect__inner c-desk__wrap">

          <!-- Video -->
          <div class="c-desk__video">
            <video muted playsinline webkit-playsinline ref="player" @ended="videoEnded" @canplaythrough="prepareVideo">
              <source :src="videoSrc" type="video/mp4">
            </video>
          </div>

          <!-- Cover -->
          <transition name="fade">
            <div class="c-desk__cover" v-if="!videoReady && stage === 0"></div>
          </transition>

          <div :class="['c-desk__cover--dark', 'c-desk__cover--' + stage]" v-if="darkShown"></div>

          <!-- Cover -->
          <transition name="fade-out">
            <div class="c-desk__loader" v-if="!videoReady && stage === 2">
              <div class="c-desk__loader__inner">
                <div class="sk-circle">
                  <div class="sk-circle1 sk-child"></div>
                  <div class="sk-circle2 sk-child"></div>
                  <div class="sk-circle3 sk-child"></div>
                  <div class="sk-circle4 sk-child"></div>
                  <div class="sk-circle5 sk-child"></div>
                  <div class="sk-circle6 sk-child"></div>
                  <div class="sk-circle7 sk-child"></div>
                  <div class="sk-circle8 sk-child"></div>
                  <div class="sk-circle9 sk-child"></div>
                  <div class="sk-circle10 sk-child"></div>
                  <div class="sk-circle11 sk-child"></div>
                  <div class="sk-circle12 sk-child"></div>
                </div>
              </div>
            </div>
          </transition>

          <!-- Future Landscape ======================== -->
          <transition name="quick-fade" @after-leave="darkShown = true" @before-enter="darkShown = false">
            <div class="c-desk__future" v-if="stage === 0">

              <!-- Title -->
              <header class="c-desk__header">
                <div class="o-section__container">
                  <h2 class="o-section__title">Future energy landscape</h2>
                </div>
              </header>

              <!-- Future Hotspots -->
              <ul class="c-hotspots">
                <li class="c-hotspots__item" :class="['c-hotspots__item--' + index]" @click="showFutureDetail(index)" v-for="(item, index) in futureItems" v-my-hotspot-shift>
                  <span class="c-hotspots__icon"><svg class="icon icon-plus"><use xlink:href="#icon-plus"></use></svg></span>
                  <span class="c-hotspots__text">{{ item.title }}</span>
                </li>
                <li class="c-hotspots__item c-hotspots__item--prosumer" @click="goToStage(1)" v-my-hotspot-shift>
                  <span class="c-hotspots__icon"><svg class="icon icon-plus"><use xlink:href="#icon-plus"></use></svg></span>
                  <span class="c-hotspots__text">Explore a day in the life of a domestic prosumer of the future</span>
                </li>
              </ul>

              <!-- Future Detail -->
              <transition name="quick-fade">
                <div class="c-desk__future__detail" v-if="futureId !== null" @click="showFutureDetail()">
                  <div class="c-mobland" @click.stop>
                    <div class="o-section__container c-mobland__text">
                      <div class="c-mobland__text__header">
                        <h3 class="c-mobland__title">{{ futureSection.title }}</h3>
                        <div class="c-mobland__text__header__controls">
                          <button class="c-mobland__button--desk-back" @click="showFutureDetail()"><svg class="icon icon-cross"><use xlink:href="#icon-cross"></use></svg><span class="u-hide">Back</span></button>
                        </div>
                      </div>
                      <div class="c-mobland__body" v-html="futureSection.body"></div>
                    </div>
                  </div>
                </div>
              </transition>

            </div>
          </transition>


          <!-- Clock screen ======================== -->
          <transition name="quick-fade">
            <div class="c-desk__prosume" v-if="stage === 1">

              <!-- clock -->
              <div class="c-desk__clock">
                <div class="o-aspect--square">
                  <div class="c-desk__clock__inner o-aspect__inner">
                    <div class="c-desk__clock__text">
                      <div class="c-desk__start">
                        <button class="c-desk__start__btn" @click="showProsumerDetail(0)">
                          <span class="c-desk__start__inner">
                            <span class="c-desk__start__icon"><svg class="icon icon-play"><use xlink:href="#icon-play"></use></svg></span>
                          </span>
                        </button>
                      </div>
                      <h3>Hi there, I’m Daniel</h3>
                      <p>Click the play button to explore what my day looks like in the future</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Hotspots -->
              <ul class="c-desk__prosume__hotspots">
                <li class="c-prohot" :class="['c-prohot--' + (index + 1)]" v-for="(item, index) in prosumerItems">
                  <p class="c-prohot__text">{{ item.title }}</p>
                  <div class="c-prohot__bg"></div>
                  <div class="o-aspect--square">
                    <div class="c-prohot__circle o-aspect__inner" @click="showProsumerDetail(index)">
                      <p class="c-prohot__index">{{ index + 1 }}</p>
                    </div>
                  </div>
                </li>
              </ul>

              <!-- Close -->
              <button class="c-desk__close-clock" @click="goToStage(0)">
                <svg class="icon icon-cross"><use xlink:href="#icon-cross"></use></svg>
                <span class="u-hide">Close</span>
              </button>

            </div>
          </transition>


          <!-- Detail screen ======================== -->
          <transition name="quick-fade"  @before-leave="darkShown = true" @after-enter="darkShown = false">
            <div class="c-desk__detail" v-if="stage === 2">

              <!-- Special -->
              <transition name="quick-fade">
                <div class="c-prosumer__special" v-if="drawerShown">
                  <transition name="quick-fade">
                    <div class="c-prosumer__special__popup" v-if="specialShown" v-html="prosumerSection.special[specialId].body"></div>
                  </transition>

                  <div class="c-prosumer__special__btns">
                    <button class="c-control c-control--special" @click="showSpecial(index)" v-for="(item, index) in prosumerSection.special">
                      <span class="c-control__inner"><span class="c-control__text">{{ item.title }}</span>
                        <template v-if="!specialShown"><svg class="icon icon-plus"><use xlink:href="#icon-plus"></use></svg></template>
                        <template v-else><svg class="icon icon-cross"><use xlink:href="#icon-cross"></use></svg></template>
                      </span>
                    </button>
                  </div>
                </div>
              </transition>

              <!-- controls -->
              <div class="c-controls">
                <button class="c-control c-control__throbber" :class="['c-control__throbber--' + (prosumerId - 1)]" @click="showProsumerDetail(prosumerId - 1)" v-if="prosumerId !== 0">
                  <span class="c-control__inner"><svg class="icon icon-left-arrow"><use xlink:href="#icon-left-arrow"></use></svg><span class="c-control__text">{{ prosumerItems[prosumerId - 1].time }}</span></span>
                </button>
                <button class="c-control" @click="replayVideo()">
                  <span class="c-control__inner"><svg class="icon icon-replay"><use xlink:href="#icon-replay"></use></svg><span class="c-control__text">Replay</span></span>
                </button>
                <button class="c-control" @click="showProsumerDetail()">
                  <span class="c-control__inner"><svg class="icon icon-cross"><use xlink:href="#icon-cross"></use></svg><span class="c-control__text">Close</span></span>
                </button>
                <button class="c-control c-control__throbber" :class="['c-control__throbber--' + (prosumerId + 1)]" @click="showProsumerDetail(prosumerId + 1)" v-if="prosumerId !== prosumerItems.length - 1">
                  <span class="c-control__inner"><span class="c-control__text">{{ prosumerItems[prosumerId + 1].time }}</span><svg class="icon icon-right-arrow"><use xlink:href="#icon-right-arrow"></use></svg></span>
                </button>
              </div>

              <!-- next -->
              <transition name="fade-in">
                <div class="c-prosumer__next" :class="['c-prosumer__next--' + (nextId + 1)]" v-if="nextShown">
                  <button class="c-prosumer__next__btn" @click="showProsumerDetail(nextId)">
                    <span class="c-prosumer__next__inner">
                      <span class="c-prosumer__next__icon"><svg class="icon icon-play"><use xlink:href="#icon-play"></use></svg></span>
                      <span class="c-prosumer__next__text">{{ nextText }}: {{ prosumerItems[nextId].time }}</span>
                    </span>
                  </button>
                </div>
              </transition>

              <!-- Drawer -->
              <transition name="drawer">
                <article class="c-prosumer__drawer c-drawer" v-if="drawerShown">
                  <div class="c-drawer__inner">
                    <header class="c-drawer__header">
                      <h1 class="c-drawer__title u-hide">{{ prosumerSection.title }}</h1>
                    </header>
                    <my-scrollbar class="c-drawer__body" :content="scrollBody" @link-clicked="showSpecial"></my-scrollbar>
                  </div>
                </article>
              </transition>

            </div>
          </transition>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyScrollbar from '@/components/standard/my-scrollbar'
import mixins from '@/mixins'
import { MyHotspotShift } from '@/directives/my-hotspot-shift'
import { eventBus } from '@/main'

export default {
  name: 'my-future-desk',
  mixins: [mixins],
  components: {
    MyScrollbar
  },
  directives: {
    MyHotspotShift
  },
  data () {
    return {
      player: null,
      playPromise: null,
      videoTotal: 2,
      videoCurrent: 0,
      videoReady: false,
      futureId: null,
      prosumerId: null,
      stage: 0,
      specialId: null,
      drawerShown: false,
      specialShown: false,
      nextShown: false,
      darkShown: false
    }
  },
  computed: {
    device () {
      return this.$store.state.device
    },
    videoSrc () {
      if (this.prosumerId !== null) {
        return 'https://player.vimeo.com/external/' + this.prosumerSection.code + '.hd.mp4?s=' + this.prosumerSection.auth + '&profile_id=175'
      } else {
        return 'https://player.vimeo.com/external/232034738.hd.mp4?s=65878f30647c6a4ba5ec0486f35e552e2ecd0e84&profile_id=175'
      }
    },
    futureItems () {
      return this.$store.state.content['future'] || []
    },
    futureSection () {
      return (this.futureId !== null) ? this.futureItems[this.futureId] : null
    },
    prosumerItems () {
      return this.$store.state.content['prosumer'] || []
    },
    prosumerSection () {
      return (this.prosumerId !== null) ? this.prosumerItems[this.prosumerId] : null
    },
    nextId () {
      return (this.prosumerId + 1 < this.prosumerItems.length) ? this.prosumerId + 1 : 0
    },
    nextText () {
      return (this.nextId === 0) ? 'Restart' : 'Next'
    },
    scrollBody () {
      return '<p><strong>' + this.prosumerSection.time + '</strong></p>' + this.prosumerSection.body
    }
  },
  methods: {
    resetVideo () {
      this.videoCurrent = 0
      this.player.pause()
      this.player.currentTime = '0'
    },
    videoEnded () {
      if (this.stage !== 2) {
        this.videoCurrent++
        if (this.videoCurrent < this.videoTotal) {
          this.player.play()
        } else {
          this.resetVideo()
        }
      } else {
        this.nextShown = true
      }
    },
    prepareVideo () {
      if (!this.videoReady) {
        this.videoReady = true
        this.player.play()
      }
      if (this.stage === 2) {
        this.drawerShown = true
      }
    },
    replayVideo () {
      this.player.pause()
      this.player.currentTime = '0'
      this.player.play()
    },
    showFutureDetail (id = null) {
      this.futureId = id
      if (id !== null) {
        // console.log('Section: ' + this.futureSection.title)
        window.gtag('event', 'interactive_future', { 'event_label': this.futureSection.title })
      }
    },
    goToStage (id) {
      this.scrollToSection(null, () => {
        this.stage = id
        if (this.stage === 0) {
          this.resetVideo()
          this.resetAll()
          this.videoReady = true
          this.player.play()
        }
        window.gtag('event', 'interactive_section', { 'event_label': 'Stage: ' + this.stage })
      })
    },
    showProsumerDetail (id = null) {
      this.scrollToSection(null, () => {
        this.prosumerId = id
        this.resetAll()
        setTimeout(() => {
          this.player.load()
        }, 0)
        this.stage = (id !== null) ? 2 : 1

        if (id !== null) {
          // console.log('Section: ' + this.prosumerSection.time)
          window.gtag('event', 'interactive_prosumer', { 'event_label': 'Section: ' + this.prosumerSection.time })
        }
      })
    },
    showSpecial (id = 0) {
      this.specialId = id
      this.specialShown = !this.specialShown
    },
    resetAll () {
      this.nextShown = false
      this.specialShown = false
      this.drawerShown = false
      this.videoReady = false
      // this.coverShown = true
    }
  },
  mounted () {
    this.player = this.$refs.player
    eventBus.$on('section-inview', (val = true) => {
      if (this.stage !== 0) return
      this.playPromise = this.player.play()
      if (this.playPromise instanceof Promise) {
        this.playPromise.then(() => {
          if (val === false) {
            this.player.pause()
          }
        })
      } else {
        if (val === false) {
          this.player.pause()
        }
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// MyFutureDesk.vue?3b08c7e0